import { TestIssueService } from '@/api/testIssue';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { Button, Dialog, Modal, ModalRef } from 'alurkerja-ui';
import React, { useRef } from 'react';
import { FaUnlink } from 'react-icons/fa';

type DeleteTestIssueProps = {
  id: string;
  onSuccess: () => void;
};

export const UnlinkTestIssue: React.FC<DeleteTestIssueProps> = ({
  id,
  onSuccess,
}) => {
  const ref = useRef<ModalRef>(null);
  const {  mutate, isPending: isLoading } =
    TestIssueService.useUnlink();

  const mutateAction = (id: string) => {
    mutate(id, {
      onSuccess: () => {
        Dialog.success({
          title: 'Success',
          description: 'Issue has been unlinked',
          callback: () => {
            onSuccess();
            ref.current?.closeModal();
          },
        });
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to unlink issue',
        });
      },
    });
  };

  return (
    <Modal
      ref={ref}
      triggerButton={
        <Button
          className="bg-yellow-500"
        >
          <FaUnlink />
        </Button>
      }
      title="Delete Issue"
    >
      {({ closeModal }) => {
        return (
          <div className="flex flex-col gap-4 p-4">
            <p className="text-gray-500">
              Are you sure you want to unlink this issue? This action cannot be
              undone.
            </p>

            <div className="flex flex-row gap-2">
              <OutlineButton onClick={closeModal}>Cancel</OutlineButton>
              <Button
                type="button"
                color="red"
                onClick={() => mutateAction(id)}
                loading={isLoading}
              >
                Unlink
              </Button>
            </div>
          </div>
        );
      }}
    </Modal>
  );
};
